import { AnyAction } from 'redux';
import {
	RESET_SEARCHBAR,
	SET_SEARCH_INPUT_VALUE,
	SET_SEARCH_PLACEHOLDER,
	SET_SEARCH_QUERY
} from '../types/types';

const initialState = {
	activated: false,
	searchQuery: '',
	searchInputValue: '',
	searchPlaceholder: 'Search...'
};

export default function searchBarReducer(
	state = initialState,
	action: AnyAction
) {
	switch (action.type) {
		case SET_SEARCH_PLACEHOLDER:
			return {
				activated: true,
				searchQuery: '',
				searchInputValue: '',
				searchPlaceholder: action.payload
			};
		case SET_SEARCH_QUERY:
			return {
				...state,
				activated: true,
				searchQuery: action.payload
			};
		case SET_SEARCH_INPUT_VALUE:
			return {
				...state,
				searchInputValue: action.name
			};
		case RESET_SEARCHBAR:
			return { initialState };
		default:
			return state;
	}
}
